import { render, staticRenderFns } from "./BranchSelectionTable.vue?vue&type=template&id=8aed3508&"
import script from "./BranchSelectionTable.vue?vue&type=script&lang=js&"
export * from "./BranchSelectionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8aed3508')) {
      api.createRecord('8aed3508', component.options)
    } else {
      api.reload('8aed3508', component.options)
    }
    module.hot.accept("./BranchSelectionTable.vue?vue&type=template&id=8aed3508&", function () {
      api.rerender('8aed3508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/BranchSelectionTable.vue"
export default component.exports